// extracted by mini-css-extract-plugin
export default {"viewEventPage":"Events_viewEventPage__MShxz"};